import PreUI from 'pre-ui';

import ApexoPopup from '@/components/Elements/ApexoPopup.vue';
import ApexoSelect from '@/components/Elements/ApexoSelect.vue';
import ApexoTextarea from '@/components/Elements/ApexoTextarea.vue';

export default {
    install(Vue) {
        Vue.use(PreUI);

        Vue.component('ApexoPopup', ApexoPopup);
        Vue.component('ApexoSelect', ApexoSelect);
        Vue.component('ApexoTextarea', ApexoTextarea);
    },
};
